module.exports = __webpack_public_path__ + "img/molly.6dfa1e41.png";